import { SimpleReveal } from '@/hooks/useSimpleAnimation';
interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  className?: string;
  id?: string;
}
const SectionHeader = ({
  title,
  subtitle,
  description,
  className = "",
  id
}: SectionHeaderProps) => {
  return <SimpleReveal className={`text-center ${className}`}>
      {/* Red line with gradient */}
      {title && <div className="mb-4">
          <div className="w-16 h-0.5 mx-auto bg-gradient-to-r from-[hsl(var(--color-1))] via-[hsl(var(--color-3))] to-[hsl(var(--color-1))] animate-gradient" style={{
        backgroundSize: '200% 100%'
      }} />
        </div>}
      
      {/* Main heading */}
      {subtitle && <h2 id={id} className="text-section-title mb-component-md capitalize">
          {subtitle}
        </h2>}
      
      {/* Description */}
      {description && <p className="text-section-description max-w-5xl mx-auto">
          {description}
        </p>}
    </SimpleReveal>;
};
export default SectionHeader;